import React, { useCallback } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import metadata from './PolicySummaryExclusionsComponent.metadata.json5';

function PolicySummaryExclusions(props) {
    const {
        policy,
        coverages
    } = props;

    const RecreationalVehicleExclusionPublicID = 'zaeiebe1rv1mq29ff3rh47ado1a';
    const NamedDriverExclusionPublicID = 'z5dhofjomobncfjg29r113gilea';
    const DesignatedMotorVehicleRecreationExclusionPublicID = 'zvnik90eq07u8f0qqoe2ir4p8kb';
    const WaterExclusionPublicID = 'zg9iod83irqtc38p5435ujk1ipb';
    const locationExclusionPublicID = 'zlchanus8hsjn9ohilop9jnl9jb';
    const PrivateStructureExclusionPublicID = 'zpois5mq4sogr6u6tr8gsoqu22a';
    const MotorCycleExclusionPublicID = 'zasiivekqk22k2s35007p1005gb';
    const driverExclusions = _.filter(policy.vehicleOperators.children, (op) => op.driverType.value === 'excluded');
    const vehicleExclusions = _.filter(policy.vehicles.children, (veh) => veh.excluded.value);
    const watercraftExclusions = _.filter(policy.watercrafts.children, (wc) => wc.isExcluded.value);
    const locationExclusions = _.filter(policy.locations.children, (loc) => loc.isExcluded.value);
    const animalExclusion = _.filter(coverages.liabilityExclusions.children, (exc) => exc.publicID.value === 'z4rjgpeqdvn74ag16f5b1u86hma');

    const liabilityExclusions = coverages.liabilityExclusions.children;
    const privateExclusion = _.filter(liabilityExclusions, (exc) => exc.publicID.value === PrivateStructureExclusionPublicID);
    const driverExclusion = _.filter(liabilityExclusions, (exc) => exc.publicID.value === NamedDriverExclusionPublicID);
    const vehicleExclusion = _.filter(liabilityExclusions, (exc) => exc.publicID.value === RecreationalVehicleExclusionPublicID);
    const designatedMotorVehicleExclusion = _.filter(liabilityExclusions, (exc) => exc.publicID.value === DesignatedMotorVehicleRecreationExclusionPublicID);
    const waterCraftExclusion = _.filter(liabilityExclusions, (exc) => exc.publicID.value === WaterExclusionPublicID);
    const locationExclusion = _.filter(liabilityExclusions, (exc) => exc.publicID.value === locationExclusionPublicID);
    const motorCycleExclusion = _.filter(liabilityExclusions, (exc) => exc.publicID.value === MotorCycleExclusionPublicID);

    const showPrivateStructureExclusion = privateExclusion.length !== 0 ? privateExclusion[0].selected.value : false;
    const showDriverExclusion = driverExclusion.length !== 0 ? (driverExclusion[0].selected.value || driverExclusions.length > 0) : driverExclusions.length > 0;
    const showVehicleExclusion = vehicleExclusion.length !== 0 ? (vehicleExclusion[0].selected.value || vehicleExclusions.length > 0) : vehicleExclusions.length > 0;
    const showDesignatedMotorVehicleRecreationExclusion = designatedMotorVehicleExclusion.length !== 0 ? designatedMotorVehicleExclusion[0].selected.value : false;
    const showWatercraftExclusion = waterCraftExclusion.length !== 0 ? (waterCraftExclusion[0].selected.value || watercraftExclusions.length > 0) : watercraftExclusions.length > 0;
    const showLocationExclusion = locationExclusion.length !== 0 ? (locationExclusion[0].selected.value || locationExclusions.length > 0) : locationExclusions.length > 0;
    const showMotorcycleExclusion = motorCycleExclusion.length !== 0 ? motorCycleExclusion[0].selected.value : false;

    const showExclusions = showDriverExclusion
        || showVehicleExclusion
        || showWatercraftExclusion
        || showLocationExclusion
        || (animalExclusion.length > 0 && animalExclusion[0].selected)
        || showPrivateStructureExclusion
        || showMotorcycleExclusion
        || showDesignatedMotorVehicleRecreationExclusion;

    const generateVehiclesOverrides = useCallback(() => {
        const vehicleOverrides = vehicleExclusions.map((vehicle, index) => {
            return {
                [`vehicleDetails${index}`]: {
                    content: `${vehicle.year.value}  ${vehicle.make.value}  ${vehicle.model.value} ${vehicle.trim_ML.value}`
                }
            };
        });

        const watercraftOverrides = watercraftExclusions.map((watercraft, index) => {
            return {
                [`watercraftDetails${index}`]: {
                    content: `${watercraft.year.value}  ${watercraft.make.value}  ${watercraft.model.value}`
                }
            };
        });

        return Object.assign({}, ...vehicleOverrides, ...watercraftOverrides);
    }, [vehicleExclusions, watercraftExclusions]);

    const generateLocationOverrides = useCallback(() => {
        const locationOverrides = locationExclusions.map((location, index) => {
            return {
                [`addressLine1${index}`]: {
                    visible: !!location.address.addressLine1.value,
                    content: location.address.addressLine1.value
                },
                [`addressLine2${index}`]: {
                    visible: !!location.address.addressLine2.value,
                    content: location.address.addressLine2.value
                },
                [`addressLine3${index}`]: {
                    visible: !!location.address.addressLine3.value,
                    content: location.address.addressLine3.value
                },
                [`cityStateCode${index}`]: {
                    content: `${location.address.city.value}, ${location.address.state.value} ${location.address.postalCode.value}`
                }
            };
        });

        return Object.assign({}, ...locationOverrides);
    }, [locationExclusions]);

    const overrideProps = {
        exclusionsRowContainer: {
            visible: showExclusions
        },
        driverExclusions: {
            visible: showDriverExclusion
        },
        driverExclusionIterable: {
            data: driverExclusions
        },
        emptyDriverExclusions: {
            visible: driverExclusions.length === 0
        },
        vehicleExclusions: {
            visible: showVehicleExclusion
        },
        vehicleExclusionIterable: {
            data: vehicleExclusions
        },
        emptyVehicleExclusions: {
            visible: vehicleExclusions.length === 0
        },
        watercraftExclusions: {
            visible: showWatercraftExclusion
        },
        watercraftExclusionIterable: {
            data: watercraftExclusions
        },
        emptyWatercraftExclusions: {
            visible: watercraftExclusions.length === 0
        },
        locationExclusions: {
            visible: showLocationExclusion
        },
        locationIterable: {
            data: locationExclusions
        },
        emptyLocationExclusions: {
            visible: locationExclusions.length === 0
        },
        privateStructureExclusion: {
            visible: showPrivateStructureExclusion
        },
        animalExclusion: {
            visible: animalExclusion.length > 0 && animalExclusion[0].selected
        },
        motorcycleExclusion: {
            visible: showMotorcycleExclusion
        },
        motorVehicleRecreationExclusion: {
            visible: showDesignatedMotorVehicleRecreationExclusion
        },
        ...generateVehiclesOverrides(),
        ...generateLocationOverrides()
    };

    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrideProps} />;
}

PolicySummaryExclusions.propTypes = {
    policy: PropTypes.shape({}).isRequired,
    coverages: PropTypes.shape({}).isRequired
};

export default PolicySummaryExclusions;
